export const CAMPAIGN_TYPES =  {
  default: 0,
  gating: 1
};